import React, { FC } from 'react';

import './_summary-sidebar.scss';

export const SummarySidebar: FC = () => (
  <div className="player__summary-sidebar" />
);
